import { Flex } from '@hopin-team/ui-flex';
import styled from 'styled-components';

const Wrapper = styled(Flex)`
  max-width: 30rem;
`;

export { Wrapper };
